import { Pipe, PipeTransform } from '@angular/core';
import { List, ListIterator, map, transform } from 'lodash';

@Pipe({
  name: 'mapPipe',
  standalone: true,
})
export class MapPipe implements PipeTransform {
  transform<T, TResult>(
    value: List<T> | null | undefined,
    iteratee: ListIterator<T, TResult>
  ): TResult[];
  transform<T, TResult>(
    value: List<T> | null | undefined,
    iteratee: string
  ): TResult[];
  transform<T, TResult>(
    value: List<T> | null | undefined,
    iteratee: ListIterator<T, TResult> | string
  ): TResult[] {
    if (typeof iteratee === 'string') {
      return map(value, iteratee);
    }
    return map(value, iteratee);
  }
}
